import { registerLicense } from '../../misc/Certificates/LicenseRegistry.js';
/**
 * License for giving somebody else access to data.
 */
export const AccessUnversionedObjectLicense = Object.freeze({
    $type$: 'License',
    name: 'AccessUnversionedObject',
    description: '[signature.issuer] gives permission to share [data] with [person].'
});
registerLicense(AccessUnversionedObjectLicense, 'AccessUnversionedObjectCertificate');
export const AccessUnversionedObjectCertificateRecipe = {
    $type$: 'Recipe',
    name: 'AccessUnversionedObjectCertificate',
    rule: [
        {
            itemprop: 'person',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'data',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['*']) }
        },
        {
            itemprop: 'license',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['License']) }
        }
    ]
};
export const AccessUnversionedObjectCertificateReverseMap = [
    'AccessUnversionedObjectCertificate',
    new Set(['*'])
];
//# sourceMappingURL=AccessUnversionedObjectCertificate.js.map